


export const dateBrToDb = (date) => {
    date = date.split('/').reverse().join('-')
    return date;
}

export const dateDbToBr = (date) => {
    date = date.split('-').reverse().join('/')
    return date;
}

export const calculaDiffDatas = (dtIni, dtFim) => {
    const diffEmMilissegundos = Math.abs(dtFim.getTime() - dtIni.getTime());
    const diffEmDias = Math.floor(diffEmMilissegundos / (1000 * 60 * 60 * 24));
    return diffEmDias

}

export const limpaTelefone = (numero) => {

    return numero.replace(/[\(\)\.\s-]+/g, '');

}
export const float2moeda = (num) => {

    let x = 0;
    let cents;
    let ret;
    if (num < 0) {
        num = Math.abs(num);
        x = 1;
    }
    if (isNaN(num)) num = "0";
    cents = Math.floor((num * 100 + 0.5) % 100);

    num = Math.floor((num * 100 + 0.5) / 100).toString();

    if (cents < 10) cents = "0" + cents;
    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
        num = num.substring(0, num.length - (4 * i + 3)) + '.'
            + num.substring(num.length - (4 * i + 3));
    ret = num + ',' + cents;
    if (x == 1) ret = ' - ' + ret; return ret;

}

export const moeda2float = (moeda) => {

    moeda = moeda.replace(".", "");

    moeda = moeda.replace(",", ".");

    return parseFloat(moeda);

}


export const limpaCpf = (cpf) => {

    return cpf.replace(/[^\d]/g, '')

}
export const Funcoes = {
    dateBrToDb,
    dateDbToBr,
    limpaTelefone,
    moeda2float,
    float2moeda
}
